import { put, call, takeEvery, select } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import { sagaActions } from '../sagas'
import {
  positionLayoutGroup,
  addLayoutGroup as addBoardGroupToLayout,
  removeLayoutGroup as removeBoardGroupFromLayout
} from '../redux/layouts'
import {
  add as addLayoutGroup,
  remove as removeLayoutGroup,
  setName as setBoardGroupName,
  addElement as addElementToLayoutGroup,
  setElement as setElementInLayoutGroup,
  removeElement as removeElementFromLayoutGroup,
  positionElement as positionLayoutGroupElement
} from '../redux/layoutGroups'
import {
  add as addBoard,
} from 'store/redux/boards'
import { push } from 'index'
import { CHANNEL_DATA } from 'CHANNEL_DATA'

const makeLayoutChannelData = (layoutId) => {
  return function * layoutChannelData (action) {
    const { channel, actionName, elementName, data } = action.payload

    const state = yield select()

    const currentUserId = state.kanbo.currentUser.id

    if (channel === `homeLayout-${layoutId}`) {
      if (actionName + elementName === 'AddBoardToLayoutGroup/Data/BoardInLayout') {
        const { LayoutId, GroupId, Id, BoardId, Position } = data

        try {
          const Board = yield call(apiGetData, 'BoardTile', {
            id: BoardId
          })

          yield put(addBoard({
            id: Board.Id,
            name: Board.Name,
            background: Board.Background,
            isObserved: Board.IsObserved,
            hasAccess: true,
            isClosed: Board.IsClosed,
            isTemplate: Board.IsTemplate,
            isPublic: Board.IsPublic,
            isLocked: Board.IsLocked,
            permissionLevel: Board.PermissionLevel,
          }))
        } catch (error) {
          if (error.code === 601) {
            yield put(addBoard({
              id: BoardId,
              name: '',
              background: null,
              isObserved: false,
              hasAccess: false,
              isClosed: false,
              isTemplate: false,
              isPublic: false,
              permissionLevel: 0
            }))
          }
        }

        yield put(addElementToLayoutGroup({
          key: `${LayoutId}-${GroupId}`,
          elementId: Id,
          type: 'board',
          boardId: BoardId,
          position: Position
        }))
      } else if (actionName + elementName === 'AddLinkToLayoutGroup/Data/LinkInLayout') {
        const { LayoutId, GroupId, Id, Name, Url, Position } = data

        yield put(addElementToLayoutGroup({
          key: `${LayoutId}-${GroupId}`,
          elementId: Id,
          type: 'link',
          name: Name,
          url: Url,
          position: Position
        }))
      } else if (actionName + elementName === 'ChangeLinkInLayoutGroup/Data/ChangedLinkInLayout') {
        const { LayoutId, Id, Name, Url } = data

        yield put(setElementInLayoutGroup({
          layoutId: LayoutId,
          elementId: Id,
          name: Name,
          url: Url
        }))
      } else if (actionName + elementName === 'RemoveElementFromLayoutGroup/Data/ElementInLayoutGroup') {
        const { LayoutId, GroupId, Id } = data

        yield put(removeElementFromLayoutGroup({
          key: `${LayoutId}-${GroupId}`,
          elementId: Id
        }))
      } else if (actionName + elementName === 'PositionElementInLayoutGroup/Data/LayoutGroupElement') {
        const { LayoutId, GroupId, Id, Position } = data

        yield put(positionLayoutGroupElement({
          layoutId: LayoutId,
          groupId: GroupId,
          elementId: Id,
          position: Position
        }))
      } else if (actionName + elementName === 'AddLayoutGroup/Data/LayoutGroup') {
        const { LayoutId, GroupId, Name, Position } = data

        yield put([
          addLayoutGroup({
            key: `${LayoutId}-${GroupId}`,
            id: LayoutId,
            name: Name
          }),
          addBoardGroupToLayout({
            layoutId: LayoutId,
            layoutGroupId: GroupId,
            position: Position
          })
        ])
      } else if (actionName + elementName === 'RemoveLayoutGroup/Data/LayoutGroup') {
        const { LayoutId, GroupId } = data

        yield put([
          removeBoardGroupFromLayout({
            layoutId: LayoutId,
            layoutGroupId: GroupId
          }),
          removeLayoutGroup({
            key: `${LayoutId}-${GroupId}`
          })
        ])
      } else if (actionName + elementName === 'RenameLayoutGroup/Data/LayoutGroup') {
        const { LayoutId, GroupId, Name } = data

        yield put(setBoardGroupName({
          key: `${LayoutId}-${GroupId}`,
          name: Name
        }))
      } else if (actionName + elementName === 'PositionLayoutGroup/Data/LayoutGroup') {
        const { LayoutId, GroupId, Position } = data

        yield put(positionLayoutGroup({
          layoutId: LayoutId,
          layoutGroupId: GroupId,
          position: Position
        }))
      }
    } else if (channel === 'landingPage') {
      if (actionName + elementName === 'RemoveHomeLayout/Primitive/MaybeInt32') {
        const { Value } = data

        if (layoutId === Value) {
          yield put(push('/'))
        }
      }
    } else if (channel === '@' + currentUserId) {
      if (actionName + elementName === 'HomeLayoutsPermissionChange/Data/Array<Int32>') {
        if (data.includes(layoutId)) {
          yield put(sagaActions.fetchPermissionLevelForLayout({ layoutId }))
        }
      }
    }
  }
}

export default function * layoutChannelData (boardId) {
  const channelData = makeLayoutChannelData(boardId)

  yield takeEvery(CHANNEL_DATA, channelData)
}
